module.exports = __webpack_public_path__ + "img/banner.8223ca40.png";